<template>
  <div
    class="ps-base-page ps-page ps-w-full ps-max-h-screen ps-absolute ps-bottom-0 ps-left-0 ps-z-50"
  >
    <div :class="[maxClasses]" class="mx-auto relative">
      <div
        class="ps-bg-brand-orange ps-rounded-full ps-w-24  ps-h-24  ps-flex ps-items-center ps-justify-center ps-shadow-lg ps-text-white ps ps-bubble ps-bubble-delay-100 ps-absolute ps-top-0 ps-right-0 ps-mr-12 -mt-12  z-30"
      >
        <div class="ps-w-3/5">
          <svg-icon
            name="picnic-logo"
            class="ps-text-white"
            width="100%"
            height="auto"
            :fill="true"
          />
        </div>
      </div>
      <div
        :class="[maxClasses]"
        class="ps-my-24 ps-bg-brand-brown-25 overflow-hidden ps-max-h-full shadow-xl sm:rounded-lg  mx-auto ps-border-gray"
      >
        <slot name="header" />
        <div class="">
          <slot />
        </div>
        <the-footer />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from '@picnic-software/vuex'
import { ROUTE_CONTROLS, ROUTE_HELP } from '@/common/constants'
import TheFooter from '@/components/TheFooter'

import '@/icons/close'

export default {
  name: 'BasePage',
  props: {
    maxWidth: {
      type: String,
      default: null
    },
    showFooter: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TheFooter
  },
  computed: {
    maxClasses() {
      return this.maxWidth
    }
  },
  methods: {
    ...mapMutations({
      routerTo: 'router/to'
    }),
    closeModal() {
      this.routerTo(ROUTE_CONTROLS)
    },
    showHelp() {
      this.routerTo(ROUTE_HELP)
    },
    makePolicyUrl(slug) {
      return `${this.marketingUrl}/policies/${slug}`
    }
  }
}
</script>

<style lang="postcss" scoped>
.ps-base-page {
  & * {
    @apply .pointer-events-auto;
  }
}

.ps-page {
  transition: all 350ms ease;
  will-change: transform;
  transform: translateY(calc(100% + 2rem));
  &.ps-is-active {
    transform: translateY(0);
    transition-delay: 200ms;
  }
}
</style>
